const deleteTruckDriverUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteTruckDriverUseCase;